/**
 * 报文头部信息
 */
class ContextModel {
  constructor () {
    this.token = ''
    this.version = ''
    this.from = '2'  //来源(0-PC,1-IPAD,2-手机)
    this.mchid = ''
    this.appid = ''
    this.timestamp = '' //时间戳
  }
}

const context = new ContextModel()

export default context


// WEBPACK FOOTER //
// ./src/wbap-core-commit/model/contextModel.js